export default __webpack_public_path__ + "static/media/video_fundal.43e57294.jpeg";